import _isEmpty from 'lodash/isEmpty';
export default function sendCDLEvent(_ref) {
  let {
    cdl
  } = _ref;
  window.coxAutoDataLayer = window.coxAutoDataLayer || [];
  if (!_isEmpty(cdl)) {
    const eventData = {
      event: {
        ...cdl.eventProperties?.event
      }
    };
    window.coxAutoDataLayer.push(eventData);
  }
}